module["exports"] = [
  "co.uk",
  "com",
  "biz",
  "info",
  "name"
];
